import { mutatorAction } from 'satcheljs';
import cortanaComposeStore from '../store/cortanaComposeStore';

export default mutatorAction(
    'updateCurrentSearchCorrelationId',
    function updateCurrentSearchCorrelationId(correlationId: string) {
        cortanaComposeStore.currentSearchCorrelationId = correlationId;
    }
);
